<template>
  <div class="container">
    <Header @needLogin="needLogin" :userInfo="userInfo"></Header>
    <router-view @needLogin="needLogin" @goregister="goregister" :userInfo="userInfo" @editUserInfo="editUserInfo" @saveGiftsUser="saveGiftsUser" @refreshLogin="refreshLogin">
      <router-view></router-view>
    </router-view>
    <LoginDialog v-if="isneedLogin" :isneedLogin="isneedLogin" @goregister="goregister" @needLogin="needLogin" @saveGiftsUser="saveGiftsUser"></LoginDialog>
    <RegisterDialog v-if="showRegister" :showRegister="showRegister" @goregister="goregister" @saveGiftsUser="saveGiftsUser" :userInfo="userInfo" :isedit="isedit" @unedit="isedit = false"></RegisterDialog>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/footer.vue'
import LoginDialog from '@/components/login.vue'
import RegisterDialog from '@/components/register.vue'
export default {
  name: 'Layout',
  components: {
    Header,
    Footer,
    LoginDialog,
    RegisterDialog
  },
  data() {
    return {
      isneedLogin: false,
      showRegister: false,
      userInfo: {},
      isedit: false
    }
  },
  created() {
    if (new Date() > new Date(localStorage.getItem('validity_time'))) {
      localStorage.removeItem('giftsUser')
    }
    this.userInfo = localStorage.getItem('giftsUser') ? JSON.parse(localStorage.getItem('giftsUser')) : {}
  },
  methods: {
    needLogin(type) {
      this.isneedLogin = type
    },
    refreshLogin(type) {
      localStorage.removeItem('giftsUser')
      this.userInfo = {}
      this.isneedLogin = type
    },
    goregister(type) {
      this.isneedLogin = false
      this.showRegister = type
    },
    saveGiftsUser(data) {
      console.log('saveGiftsUser')
      this.userInfo = data.giftsUser
      localStorage.setItem('token', data.token)
      localStorage.setItem('key', data.key)
      localStorage.setItem('deskey', data.deskey)
      localStorage.setItem('validity_time', data.validity_time)
      localStorage.setItem('giftsUser', JSON.stringify(data.giftsUser))
    },
    editUserInfo(type) {
      this.isedit = type
      this.showRegister = type
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  overflow-y: auto;
}
</style>